<template>
	<div>
		<h1>{{id}}</h1>
		<div class="about">
        	<!-- <p>{{ aktivitetInfo }}</p> -->
            <p v-html="aktivitetInfo"></p>
        </div>
	</div>
</template>


<script>
export default {
	data() {
		return {
			id: this.$route.params.id,
			aktiviteter: [
				{title: 'Mandag', text: 'Mandager kan barna ha med seg leker som de viser frem til de andre barna i barnehagen.<br>De får da vise frem lekene sine i samlingsstund, grunnen til dette er at  de skal øve seg på å snakke høyt i en gruppen med flere tilhørere.  De får også øvd seg på å gi og ta imot ros.', bilde: "gutt.jpg",},
                {title: 'Tirsdag', text: 'Tirsdager er vi i vålehallen. Her har vi da muligheten til å utvikle de motoriske ferdighetene våre. Barna kan være inne å løpe uansett hvordan været er ute.<br>Vi er her sammen med Ole Brum familiebarnehage.', bilde: 'trafikklys.jpg'},
                {title: 'Onsdag', text: 'Onsdager er vi på tur i nærområdet. Vi er steder vi kan gå til som for eksempel Bibo, prestegården, Fjellborg og lekeplassen.<br>Vi er ofte på tur sammen med Ole Brum familiebarnehage.', bilde: 'trilleLov.jpg'},
                {title: 'Torsdag', text: 'Torsdager deler vi barna inn i grupper etter alder. Vi jobber da med ulike oppgaver. Vi spiller spill, jobber med prosjekter  og lærer oss farger og konkretiserer tall og mengder.', bilde: 'sandkasse.jpg'},
                {title: 'Fredag', text: 'Fredager er det ordensbarnet som bestemmer hva vi skal gjøre i samlingen. Barnet bestemmer hva vi skal gjøre og når vi skal gjøre de ulike tingene (med hjelp fra en voksen) Fredager har vi også en fredagsboks som barna ikke vet hva vi har oppi. Barna rister da på boksen for å finne ut hva som befinner seg i boksen, før de gjetter på hva den inneholder.', bilde: 'ski.jpg'},
            ],
            test: '<p>hm<br>m</p> '
		}
	},
	computed: {
        aktivitetInfo() {
            let title = this.aktiviteter.filter( aktiviteter => aktiviteter.title.toLowerCase().startsWith(this.id.toLowerCase()))
            return title[0].text
        }
    },
}
</script>

<style scoped>
.about {
  margin-left: 10%;
  margin-right: 10%;
  text-align: left;
}
@media screen and (min-width: 1001px) {
  p {
    font-size:1.25vw;
    margin-bottom: 0%;
  }
}
</style>